export const Send = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 5L27 16L5 27L8.06977 16L5 5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 16H8" stroke="currentColor" stroke-width="2"/>
</svg>`;
